module.exports = __webpack_public_path__ + "img/fileicon.2702edae.svg";